export default function Home() {
  return (
    <div className="public-home">
      <img src="/shamrock-green.png" alt="Ryan Companies" className="public-home-logo" />
      <h1>Ryan Companies</h1>
      <p>Scan an employee&apos;s QR code to open their digital business card.</p>
    </div>
  );
}
